<template>
  <div class="tag">
    {{ duration }}
  </div>
</template>

<script>
export default {
  props: {
    duration: { type: String, required: true }
  }
}
</script>

<style lang="scss" scoped>
  .tag {
    display: inline-block;
    background: rgba(#ff8000, .9);
    background: rgba(#000, .5);
    color: #fff;
    font-weight: 700;
    padding: 1px 4px;
    border-radius: 4px;
    font-size: 12px;
    z-index: 5;

    &.position--bottom-right {
      position: absolute;
      bottom: 5px;
      right: 5px;
    }
  }
</style>